import { Component, OnInit, OnDestroy } from '@angular/core';
import { IzvestajBaseComponent } from '../izvestaj-base/izvestaj-base.component';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';

import {
  BackendService,
  TableSettings,
  FieldStructure,
  ListService,
  NotificationService,
  FieldMapItem,
  TableActionEnum,
} from 'beyond-util';

import { IzvestajSettings } from '../prihodi-po-emisijama/izvestaj-settings.service';
import { ExportService } from '../../../services/export.service';
import { ReportService } from '../../../services/report.service';
import { DnevniPlanEmitovanja } from '../../../models/DnevniPlanEmitovanja/dnevni-plan-emitovanja';
import { MimeFileType } from '../../../enums/mime-file-type.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { UtilServiceClient } from '../../../services/util.service';
import { ReportNameEnum } from '../../../enums/report-name.enum';
import { EndpointTypeEnum } from '../../../enums/endpoint-type.enum';
import { RGatewayRequest } from '../../../models/RGatewayRequest';
@Component({
  selector: 'app-dnevni-plan-emitovanja',
  templateUrl: './dnevni-plan-emitovanja.component.html',
})
export class DnevniPlanEmitovanjaComponent extends IzvestajBaseComponent
  implements OnInit, OnDestroy {
  private chosenProgram;
  private canGenerate = false;
  private EmisijaFieldMapItem: FieldMapItem;

  public orderList: any[] = [];

  constructor(
    protected _backendService: BackendService,
    protected izvestajSettings: IzvestajSettings,
    protected exportService: ExportService,
    protected listService: ListService,
    protected reportService: ReportService,
    protected notificationService: NotificationService,
    protected _rtsBackendService: RtsBackendService,
    protected _listService: ListService,
    protected utilService: UtilServiceClient,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService);
    this.name = 'Dnevni plan emitovanja';
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      this.fetchProgrami();
      super.ngOnInit();
      this.report = {
        datum: new Date(),
      };
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  fetchProgrami() {
    this._rtsBackendService
      .fetchSettings(
        FormCode.MSPRO_PRO,
        FormName.PregledProgama,
        EndpointTypes.AllEntities
      )
      .subscribe(response => {
        this._spinner.hide();
        const programi = response.ServiceData.Data;
        const parsed = this.utilService.parseEnum(programi);
        this._listService.registerEnum('MSEMI_EMI_ProgramIdEnum', parsed);
      });
  }

  settingsLoadSingle() {
    setTimeout(() => {
      const data = this.izvestajSettings.dnevniPlanEmitovanjaTableSettings;
      this.settingsData = data;
      this.settingsTable = new TableSettings(this.settingsData, 'table');
      this.settingsTableSource.next(this.settingsTable);

      this.fieldStructure = new FieldStructure(
        this.izvestajSettings.dnevniPlanEmitovanjaHeaderSettings,
        'header'
      );
      this.toggleEditableField('Emisija', false);
      this.toggleEditableField('Klijent', false);

      this.firstTableLoad();
      this.refreshTable();

      this.EmisijaFieldMapItem = this.fieldStructure.getFieldByName('Emisija');
      this.EmisijaFieldMapItem.lookupInitFilter = [
        {
          name: 'datumEmitovanja',
          value: moment(this.report.datum).format('YYYY-MM-DD'),
        },
      ];
    }, 0);
  }

  refreshTable() {
    this.documentListSource.next(this.orderList);
  }

  validateTableData() {
    if (!this.orderList.length) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      return true;
    }

    if (!this.canGenerate) {
      this.notificationService.notyError(
        `Kako bi kreirali izvestaj za zadati datum i program morate prvo da filtrirate podatke.`
      );

      return true;
    }

    return false;
  }

  toggleEditableField(fieldName: string, isEditable: boolean) {
    const field: FieldMapItem = this.fieldStructure.getFieldByName(fieldName);
    field.additable = isEditable;
    field.editable = isEditable;
  }

  checkForEmptyFields() {
    let retVal = false;

    if (!this.report.datum && this.report.program) {
      this.notificationService.notyError('Niste izabrali datum.');

      retVal = true;
    }
    if (!this.report.program && this.report.datum) {
      this.notificationService.notyError('Niste izabrali program.');

      retVal = true;
    }
    if (!this.report.datum && !this.report.program) {
      this.notificationService.notyError('Niste izabrali program i datum.');

      retVal = true;
    }

    return retVal;
  }

  getLookupFilterIds() {
    if (this.checkForEmptyFields()) {
      return;
    }

    const filterString = this.getDnevniPlanEmitovanjaFilterString(
      moment(this.report.datum).format('YYYY-MM-DD'),
      this.report.program,
      null,
      null
    );

    const requestModel: RGatewayRequest = this.reportService.getPayload(
      filterString,
      FormCode.MSIZV_DPE,
      null,
      ReportNameEnum.DnevniPlanEmitovanja,
      EndpointTypeEnum.Form
    );

    this.reportService.getFormData(requestModel).subscribe((report: any) => {
      if (report.Errors && report.Errors.length) {
        this.notificationService.notyError(report.Errors[0].ErrorMessage);

        this.orderList = [];
        this.documentListSource.next(this.orderList);

        this.toggleEditableField('Emisija', false);
        this.toggleEditableField('Klijent', false);
        this.canGenerate = false;

        return;
      }

      this.toggleEditableField('Emisija', true);
      this.toggleEditableField('Klijent', true);

      this.orderList = report.ServiceData.Tabela;

      this.setRbr(this.orderList);
      this.documentListSource.next(this.orderList);
      this.canGenerate = true;

      const klijentIds = this.getKlijentIds(report.ServiceData.Tabela).join(
        ','
      );
      const emisijaIds = this.getEmisijaIds(report.ServiceData.Tabela).join(
        ','
      );

      this.fieldStructure.getFieldByName('Klijent').lookupInitFilter = [
        {
          name: 'ids',
          value: klijentIds,
        },
      ];

      this.fieldStructure.getFieldByName('Emisija').lookupInitFilter = [
        {
          name: 'ids',
          value: emisijaIds,
        },
      ];
    });
  }

  getKlijentIds(data: Array<any>): Array<any> {
    const array = data.map(k => {
      return k.KlijentId;
    });
    const newArr = Array.from(new Set(array));

    return newArr;
  }

  getEmisijaIds(data: Array<any>): Array<any> {
    const array = data.map(k => {
      return k.EmisijaId;
    });
    const newArr = Array.from(new Set(array));

    return newArr;
  }

  filter() {
    if (this.checkForEmptyFields()) {
      return;
    }

    this._spinner.show();

    const filterString = this.getDnevniPlanEmitovanjaFilterString(
      moment(this.report.datum).format('YYYY-MM-DD'),
      this.report.program,
      this.report.Klijent != null ? this.report.Klijent.Id : null,
      this.report.Emisija != null ? this.report.Emisija.Id : null
    );

    const requestModel: RGatewayRequest = this.reportService.getPayload(
      filterString,
      FormCode.MSIZV_DPE,
      null,
      ReportNameEnum.DnevniPlanEmitovanja,
      EndpointTypeEnum.Form
    );

    this.reportService.getFormData(requestModel).subscribe((report: any) => {
      this._spinner.hide();

      if (report.Errors && report.Errors.length) {
        this.notificationService.notyError(report.Errors[0].ErrorMessage);

        this.orderList = [];
        this.documentListSource.next(this.orderList);

        return;
      }

      this.orderList = report.ServiceData.Tabela;
      this.setRbr(this.orderList);
      this.documentListSource.next(this.orderList);
      this.canGenerate = true;
    });
  }

  setRbr(list: any[]) {
    list.forEach((l, index) => (l.rbr = index + 1));
  }

  mapReportToModel(): DnevniPlanEmitovanja {
    const dpe = new DnevniPlanEmitovanja();

    dpe.DatumEmitovanja = moment(this.report.datum).format('YYYY-MM-DD');
    dpe.ProgramNaziv = this.chosenProgram;
    dpe.Tabela = this.orderList;

    if (this.report.Emisija) {
      dpe.EmisijaNaziv = this.report.Emisija.Naziv;
    }
    if (this.report.Kupac) {
      dpe.KupacNaziv = this.report.Klijent.NazivImePrezime;
    }

    return dpe;
  }

  refreshForm() {
    this.report = {
      datum: new Date(),
    };
    this.toggleEditableField('Emisija', false);
    this.toggleEditableField('Klijent', false);
    this.orderList = [];
    this.documentListSource.next(this.orderList);
  }

  getNazivPrograma(chosenId) {
    const programi: any = this.listService.getEnum('MSEMI_EMI_ProgramIdEnum');
    const naziv = programi.find(p => p.value === chosenId);

    return naziv.label;
  }

  onReportValueChanged(event) {
    if (event) {
      switch (event.fieldMap.fieldKey) {
        case 'datum':
          this.report = {
            datum: moment(event.newValue).format('YYYY-MM-DD'),
            program: this.report.program,
          };

          this.getLookupFilterIds();
          break;
        case 'program':
          this.chosenProgram = this.getNazivPrograma(event.newValue);
          this.getLookupFilterIds();

          this.report = {
            datum: this.report.datum,
            program: event.newValue,
          };

          if (event.newValue) {
            this.canGenerate = false;
          }
          break;
        case 'Klijent':
          this.report.Klijent = event.newValue;
          if (event.newValue) {
            this.canGenerate = false;
          }
          break;
        case 'Emisija':
          this.report.Emisija = event.newValue;
          if (event.newValue) {
            this.canGenerate = false;
          }
          break;
      }
    }
  }

  setFieldLookupInitFilter(
    fieldName: string,
    filterName: string,
    filterValue: any
  ) {
    const field: FieldMapItem = this.fieldStructure.getFieldByName(fieldName);
    field.lookupInitFilter = [
      {
        name: filterName,
        value: filterValue,
      },
    ];
  }

  onToolbarActionPrint() {
    if (this.validateTableData()) {
      return;
    }

    const report: DnevniPlanEmitovanja = this.mapReportToModel();
    const requestModel: RGatewayRequest = this.reportService.getPayload(
      null,
      report,
      FormCode.MSIZV_DPE,
      ReportNameEnum.DnevniPlanEmitovanja,
      EndpointTypeEnum.Pdf
    );

    this.reportService.exportToDocument(requestModel).subscribe(pdf => {
      ReportService.openBlob(pdf, MimeFileType.Pdf);
    });
  }

  getDnevniPlanEmitovanjaFilterString(
    datumEmitovanja: any,
    programId: string,
    klijentId?: string,
    emisijaId?: string
  ): string {
    const baseUrl = `?datumEmitovanja=${moment(datumEmitovanja).format(
      'YYYY-MM-DD'
    )}&programId=${programId}`;
    if (klijentId && !emisijaId) {
      return baseUrl + `&klijentId=${klijentId}`;
    }
    if (emisijaId && !klijentId) {
      return baseUrl + `&emisijaId=${emisijaId}`;
    }
    if (emisijaId && klijentId) {
      return baseUrl + `&klijentId=${klijentId}&emisijaId=${emisijaId}`;
    } else {
      return baseUrl;
    }
  }

  dnevniPlanEmitovanjaTableAction(event) {
    if (event.action === TableActionEnum.Filter) {
      this.setRbr(this.orderList);
    }
  }

  onToolbarActionExport() {
    if (this.validateTableData()) {
      return;
    }

    const entity: DnevniPlanEmitovanja = this.mapReportToModel();
    const requestModel: RGatewayRequest = this.reportService.getPayload(
      null,
      entity,
      FormCode.MSIZV_DPE,
      ReportNameEnum.DnevniPlanEmitovanja,
      EndpointTypeEnum.Xls
    );
    this.reportService.exportToDocument(requestModel).subscribe(data => {
      const formattedDate: string = `${moment(new Date()).format(
        'YYYY-MM-DD_HH:mm'
      )}`.replace(
        `${moment(new Date()).format('YYYY-MM-DD_HH:mm')}`.charAt(13),
        '-'
      );
      const fileName = `Dnevni_plan_emitovanja_${formattedDate}`;
      ReportService.downloadBlob(data, MimeFileType.Xlsx, fileName);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/dnevni-plan-emitovanja/dnevni-plan-emitovanja.component.ts